import { apiRequest, roughList, roughDelete } from "../../../../services/adapters/base";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      roughList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDelete = async (query, cancelToken) => {
    return await apiRequest(
      "post",
      roughDelete,
      {
        cancelToken: cancelToken,
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
